// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/airways.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/airways/airways.js';

mount([g0]);
